import { GtmTracker } from '@/modules/common/services/analytics';

const { trackerWithDefaultProps } = GtmTracker;

const trackAmplitudeEvent = trackerWithDefaultProps({
  page_screen: 'my_portfolio',
  digital_experience: 'investor',
  experience_section: 'portfolio'
});

export function trackViewHistoricalBalance() {
  trackAmplitudeEvent({
    event_type: 'click',
    event_name: 'view_historical_balance'
  });
}
